<template>
  <div class="wrap">
    <!--检索-->
    <el-row type="flex" justify="space-between">
      <upload-data v-if="isEditAndDelete" @success="request"></upload-data>
      <el-col>
        <div class="form-box">
          <div class="input-item">
            <el-input
              clearable
              size="medium"
              placeholder="请根据产品名称搜索"
              v-model="requestData.name_like"
            >
              <el-button
                @click="request"
                slot="append"
                icon="el-icon-search"
              ></el-button>
            </el-input>
          </div>
        </div>
      </el-col>
    </el-row>

    <!--表格数据-->
    <el-table :data="tableData" stripe style="width: 100%; margin-top: 20px;">
      <el-table-column prop="name" label="产品名称"> </el-table-column>
      <el-table-column prop="phone_number" label="上传用户">
        <template slot-scope="scope">
          {{ scope.row.nickname === '余杰' ? '徐骏' : scope.row.nickname }}
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="创建时间">
        <template slot-scope="scope">
          {{ timeFormat(scope.row.create_at) }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" align="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="medium"
            class="copy-text"
            @click="handleCopy"
            :data-clipboard-text="`https://yytools-api.mockuai.com/app/temp_activity/prd/${scope.row.name}/index.html`"
            >复制链接
            </el-button>
          <el-button
            v-if="isEditAndDelete"
            type="text"
            size="medium"
            @click="toDelete(scope.row._id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<style lang="scss" scoped>
.wrap {
  background-color: #fff;
  padding: 20px;
}
</style>

<script>
import Util from "../../js/util";
import UploadData from "./components/uploadData.vue";
import Clipboard from 'clipboard';
import {Message} from 'element-ui';

export default {
  name: "FormList",
  components: {
    UploadData
  },
  computed: {
    isEditAndDelete() {
      // 是否有删除和修改的权限
      const authStr = decodeURIComponent(lib.cookie.get("authority") || "");
      const auths = authStr.split(",");
      if (this.tabType === "1") return true;
      return auths.includes("3");
    }
  },
  data() {
    return {
      tableData: null,
      totalNumber: null,
      currentPage: 0,
      requestData: {
        page: 0,
        count: 20,
        name_like: ""
      },
      myCount: lib.cookie.get("mobile"),
      center: { lng: 120.1520955789, lat: 30.2443639356 },
      curPosition: { lng: 120.1520955789, lat: 30.2443639356 }
    };
  },

  created() {
    this.request();
  },

  methods: {
    handleCopy() {
      const clipboard = new Clipboard('.copy-text');
      clipboard.on('success', (e) => {
        Message.success({
          message: '复制成功！',
          type: 'info',
          center: true
        });
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        Message.error({
          message: '复制失败！',
          type: 'info',
          center: true
        });
        clipboard.destroy();
      });
    },
    // 时间戳格式化
    timeFormat: function(date) {
      return Util.formatTime(date);
    },
    request() {
      lib.tmsapi.get({
        api: "api/test/prd/list",
        data: this.requestData,
        success: data => {
          this.tableData = data.data;
          this.totalNumber = data.total;
        },
        error: data => {
          if (data && data.msg) {
            this.$message.error(data.msg);
          }
        },
        complete: () => {}
      });
    },
    getId(id) {
      return "form-num-" + id;
    },
    toDelete(id, e) {
      this.$confirm("此操作将删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.remove(id);
        })
        .catch(() => {
          // do sth
        });
    },

    toCheck(item) {
      lib.storage.set("formdata", item);
      this.$router.push({ path: `/form/data/${item._id}` });
    },

    viewForm(item) {
      this.$router.push({ path: `/form/view?id=${item._id}` });
    },

    toAdd() {
      this.$router.push({ path: `/form/add` });
    },

    remove(id, cb) {
      var that = this;
      lib.tmsapi.post({
        api: "api/test/prd/delete",
        data: {
          id
        },
        success: function(data) {
          that.$message.success("删除成功!");
          that.request();
        },
        error: function(data) {
          if (data && data.msg) {
            that.$message.error(data.msg);
          }
        },
        complete: function() {}
      });
    },

    handleCurrentChange(val) {
      this.requestData.page = val - 1 || 0;
      this.request();
    }
  }
};
</script>
